<dashboard-dialog-frame [icon]='icon()' header='Set Keynote Speaker' [actions]='[]' [dialogRef]='dialogRef'>

	<div class="d-flex flex-column gap-5">
		<div>
			<readonly-access [readonly]="isReadonly()"></readonly-access>
			<table style='width:100%'
				class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
				<tr>
					<td style="width: 20%;">Name</td>
					<td>
						<common-text-field [field]="name()"></common-text-field>
					</td>
				</tr>
				<tr>
					<td style="width: 20%;">Bio</td>
					<td>
						<common-text-field [field]="bio()"></common-text-field>
					</td>
				</tr>
			</table>
		</div>
		<common-button-row [center]="true">
			<button #speakerFormSaveBtn class="btn btn-primary">Save</button>
			<button class="btn btn-standard" (click)="close()">Close</button>
		</common-button-row>
	</div>
</dashboard-dialog-frame>